import { useState, useCallback } from 'react';
import axios from 'axios';
import { isAuth } from "../../../helpers/localStoreHandler";

const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const isStage = window.location.hostname === 'kritique-toolbox-stage.unileversolutions.com';
  const isLocal = window.location.hostname === 'www.kritique-dev.unileversolutions.com' || window.location.hostname === 'localhost';
  let baseURL_PROD = process.env.REACT_APP_BMP_BASE_URL_PROD;
  let xApiKey = process.env.REACT_APP_BMP_X_API_KEY_PROD;
  if (isStage || isLocal) {
    baseURL_PROD = `https://vibes-dev.unileversolutions.com/`;
    xApiKey = process.env.REACT_APP_BMP_X_API_KEY;
  }
  
  const sendRequest = useCallback(async (url, method = 'GET', data = null, headers = {}, isReload = false) => {
    // setIsLoading(!isReload ? true : false);
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios({
        method,
        url: `${baseURL_PROD}v2/kritique/bmp/api/${url}`,
        data,
        headers: {
          // 'x-api-key': xApiKey,
          'x-token': isAuth() || '',
          'Content-Type': 'application/json',
          ...headers,
        },
      });
      return response.data;
    } catch (err) {
      setError(err.message || 'Something went wrong!');
      console.error('HTTP Request Error:', err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, [baseURL_PROD, xApiKey]);

  return { sendRequest, isLoading, error };
  // return { sendRequest, error };
};

export default useHttp;
